export default {
    login: '/login',
    users: '/users',
    findAccount: '/verify-user'
}